var messages = {
  confirm: '確認',
  noOptions: 'オプションなし',
  noResults: '検索結果はありません',
  selectAll: '全てを選択',
  placeholder: '選択して下さい',
  dunhao: '、',
  searchPlaceHolder: '検索',
  reset: 'リセット',
  atLeast: '少なくとも${n}個を選択してください',
  addNew: 'クリックして作成'
};
export default messages;